import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// views

import Dashboard from "views/admin/Dashboard.js";
import Settings from "views/admin/Settings.js";
import FileMaintainance from "views/admin/FileMaintainance";
import Transaction from "components/Transaction/Transaction";
import Users from "views/admin/User";

export default function Admin() {
  return (
    <>
      <div className="flex">
        <Sidebar style={{ flex: "3" }} />
        <div className="relative bg-gray-200" style={{ flex: "6" }}>
          <AdminNavbar />
          <Switch>
            <Route path="/admin/dashboard" exact component={Dashboard} />
            {/* <Route path="/admin/maps" exact component={Maps} /> */}
            <Route path="/admin/settings" exact component={Settings} />
            <Route path="/admin/transaction/:type" component={Transaction} />
            <Route exact path="/admin/transaction" component={Transaction} />
            <Route path="/admin/users" component={Users} />
            <Route
              path="/admin/file-maintainance"
              component={FileMaintainance}
            />
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
